import styles from '@components/components/Modal/SignUpPlanModal/SignUpPlanModal.module.scss';
import MeinWienenergieLogo from '@components/images/logo-mein-wienenergie.inline.svg';
import SignUpMultiplePlanModal from '@components/components/Modal/SignUpPlanModal/SignUpMultiplePlanModal';
import { useTracking } from '@components/hooks';
import React from 'react';
import { Button, Heading, Link, Modal } from '@wienenergiegithub/ui-next';

const SignUpPlanModal = ({
  newCustomerUrl,
  newCustomerUrls,
  title,
  id,
  existingCustomerUrl,
  dialog,
  trackEvent,
  options,
  voucher,
}) => {
  const track = useTracking();
  const trackClick = interaction => {
    track({
      event: trackEvent ?? 'signupModalEvent',
      options: options || null,
      voucher: voucher || null,
      interaction,
      tarifId: id,
      tarifName: title,
    });
  };

  // check if there is a more complex signup (like for some Business Products)
  if (newCustomerUrls && newCustomerUrls.length) {
    return (
      <SignUpMultiplePlanModal
        dialog={dialog}
        existingCustomerUrl={existingCustomerUrl}
        id={id}
        newCustomerUrls={newCustomerUrls}
        title={title}
        trackEvent={trackEvent}
      />
    );
  }

  const step1Content = (
    <div className={styles.contentContainer}>
      <Heading noSpacing size="h5">
        Sind Sie bereits Kund*in?
      </Heading>
      <Heading as="h6" className={styles.answerHeading} noSpacing size="h7">
        Nein
      </Heading>
      <p className={styles.section}>
        In wenigen Schritten zu Ihrem neuen Tarif
      </p>
      <Button
        className={styles.modalButton}
        onClick={() => trackClick('click-kunde-werden')}
        render={<Link to={newCustomerUrl} />}
      >
        Kund*in werden & Tarif anmelden
      </Button>
      <Heading as="h6" className={styles.answerHeading} noSpacing size="h7">
        Ja
      </Heading>
      <p className={styles.section}>
        Wechseln Sie Ihren Tarif einfach im Service Bereich
      </p>
      <Button
        className={styles.modalButton}
        isElevated
        onClick={() => trackClick('click-tarif-wechseln')}
        render={<Link to={existingCustomerUrl} />}
        theme="tertiary"
      >
        Einloggen & Tarif wechseln
      </Button>
    </div>
  );

  return (
    <Modal
      header={<MeinWienenergieLogo height="14px" />}
      store={dialog}
      theme="secondary"
    >
      {step1Content}
    </Modal>
  );
};

export default SignUpPlanModal;
